import React from 'react';
import List, { Order, OrderingHeader, toggleOrder } from 'live/components/ui/List';
import styled from 'styled-components';
import CompanyBox from './CompanyBox'
import theme from 'live/services/theme'



const CompanyList = ({companies, selecteCompany, companySelected, deleteCompany, showDeleteCompany}) => {

   
    return (
        <div>

            <List
                items={companies}
                render={companies => (
                    <ListContainer>
                        {companies.map((company) => {
                            return <div onClick={(e) => {selecteCompany(company)}}>
                                <CompanyBox 
                                showDeleteCompany={showDeleteCompany}
                                deleteCompany={deleteCompany}
                                company={company}
                                name={company.name} 
                                users={company.users} 
                                sensors={company.sensors}
                                selected={companySelected ?  
                                    (companySelected.id === company.id ? true : false) : false }/>
                            </div>
                        })}
                    </ListContainer>
                )}
            
            />

        </div>
    )

}

export default CompanyList;

const ListContainer = styled.ul`
   
`